import { useEffect, useState } from "react";
import { CloseGreyIcon, UserGreyIcon } from "../../../assets/icons";
import { useNotification } from "../../toster-notification/NotificationContext";
import { userService } from "../../../services/userService";
import { authService } from "../../../services/authService";
import Loader from "../../shared/Loader";
import { validatePhoneNumber } from "../../../utils/validators";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { ClientProfileInfoDTO } from "../../../models/user/user.response";

interface ClientProfileEditViewProps {
    onClose: () => void;
}

const ClientProfileEditView: React.FC<ClientProfileEditViewProps> = ({ onClose }) => {

    const [clientProfileInfo, setclientProfileInfo] = useState<ClientProfileInfoDTO | null>(null);

    const [nameErrorMessage, setNameErrorMessage] = useState<string>('');
    const [phoneErrorMessage, setPhoneErrorMessage] = useState<string>('');
    const [birthDateErrorMessage, setBirthDateErrorMessage] = useState<string>('');
    const [imageFile, setImageFile] = useState<File | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const { notify } = useNotification();

    useEffect(() => {
        fetchclientProfileInfo();
    }, []);

    const fetchclientProfileInfo = async () => {
        setLoading(true);
        try {
            const response = await userService.getClientProfileInfo();
            if (response.data) {
                setclientProfileInfo(response.data);
            } else {
                notify("error", response.message || "Neuspešno učitavanje podataka o profilu.");
            }
        } catch (error: any) {
            notify("error", "Neuspešno učitavanje podataka o profilu.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateProfile = async () => {

        if (!clientProfileInfo) return;

        setNameErrorMessage('');
        setPhoneErrorMessage('');
        setBirthDateErrorMessage('');

        let isValid = true;

        if (clientProfileInfo.fullName.trim() === "") {
            setNameErrorMessage("Ime i prezime su obavezni.");
            isValid = false;
        }

        let validate = validatePhoneNumber(clientProfileInfo.phoneNumber);
        if (validate) {
            setPhoneErrorMessage(validate);
            isValid = false;
        }

        if (!isValid)
            return;

        setLoading(true);
        try {
            const form = new FormData();

            form.append('fullName', clientProfileInfo?.fullName || '');
            form.append('phoneNumber', clientProfileInfo?.phoneNumber || '');
            form.append('imageUrl', clientProfileInfo?.imageUrl || '');

            if (imageFile) {
                form.append('imageFile', imageFile);
            }

            if (clientProfileInfo?.birthDate) {
                form.append('birthDate', clientProfileInfo.birthDate.toString());
            }

            const response = await userService.updateClientProfile(clientProfileInfo.id, form);

            if (response.success) {
                notify("success", "Uspešno ste izmenili profil informacije.");
                onClose();
            } else {
                notify("error", response.message || "Došlo je do greške prilikom izmene profil informacija.");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom izmene profil informacija.");
        } finally {
            setLoading(false);
        }
    };


    const removeImageUrl = async () => {
        if (!clientProfileInfo)
            return;

        setImageFile(null);
        const updatedProfileInfo = { ...clientProfileInfo, imageUrl: "", imageFile: null };
        setclientProfileInfo(updatedProfileInfo);
    };

    const uploadImageUrl = async () => {
        if (!clientProfileInfo)
            return;

        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = 'image/*';
        fileInput.onchange = () => {
            if (fileInput.files && fileInput.files[0]) {
                const file = fileInput.files[0];
                setImageFile(file);
            }
        };
        fileInput.click();
    };

    if (loading) {
        return <Loader />;
    }

    if (!clientProfileInfo) {
        return <div>Nema podataka o profilu.</div>;
    }

    return (
        <section className="modal-section client-page-info">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">
                                    <strong>Profil informacije</strong>
                                </div>
                                <div className="description-text">Uredi svoje lične podatke na profilu</div>
                            </div>
                            <div className="modal-button-div" onClick={onClose}>
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form className="modal-form" >

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Ime i Prezime *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite ime i prezime" type="text"
                                        value={clientProfileInfo.fullName}
                                        onChange={(e) => setclientProfileInfo({ ...clientProfileInfo, fullName: e.target.value })}
                                    />
                                    <div className="error-text">{nameErrorMessage}</div>
                                </div>

                                {/* <div className="modal-form-div">
                                    <label className="modal-form-label">
                                        <strong>Email *</strong>
                                    </label>
                                    <input className="form-input grey w-input" placeholder="Unesite email" type="email"
                                        value={clientProfileInfo.email}
                                        onChange={(e) => setclientProfileInfo({ ...clientProfileInfo, email: e.target.value })}
                                    />
                                    <div className="error-text">{emailErrorMessage}</div>
                                </div> */}

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Telefon *</label>
                                    <input className="form-input grey w-input" placeholder="Unesite telefon" type="tel"
                                        value={clientProfileInfo.phoneNumber}
                                        onChange={(e) => setclientProfileInfo({ ...clientProfileInfo, phoneNumber: e.target.value })}
                                    />
                                    <div className="error-text">{phoneErrorMessage}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Datum rođenja</label>
                                    <input className="form-input grey w-input" placeholder="Unesite datum rođenja" type="date"
                                        value={clientProfileInfo.birthDate ? new Date(clientProfileInfo.birthDate).toISOString().split('T')[0] : ''}
                                        onChange={(e) => setclientProfileInfo({ ...clientProfileInfo, birthDate: e.target.value ? new Date(e.target.value) : null })}
                                    />
                                    <div className="error-text">{birthDateErrorMessage}</div>
                                </div>

                                <div className="modal-form-div">
                                    <label className="modal-form-label">Slika na profilu</label>
                                    <div className="div-block-51">
                                        <img src={imageFile ? URL.createObjectURL(imageFile) : clientProfileInfo.imageUrl ? clientProfileInfo.imageUrl + "@lg.webp" : UserGreyIcon} loading="lazy" alt="" className="image-18" />
                                    </div>
                                    <div className="div-block-52">
                                        <div className="button-primary small light-red-bg" onClick={removeImageUrl}>
                                            <div>Ukloni sliku</div>
                                        </div>
                                        <div className="button-primary small grey-bg" onClick={() => uploadImageUrl()}>
                                            <div>Izaberi novu sliku</div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            {loading ? (
                                <Loader size={30} fullscreen={false} />
                            ) : (
                                <div className="button-primary medium" onClick={handleUpdateProfile}>
                                    <div>Sačuvaj izmene</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default ClientProfileEditView;